import React, { useEffect } from 'react';
import { Button, Result } from 'antd';
import { useLocation } from 'react-router-dom';
import './AuthSuccess.style.css';

const AuthSuccess = () => {
  /* ===== ROUTE ===== */
  const location = useLocation();

  /* ===== STATE ===== */

  const isClosedRef = React.useRef(false);

  /* ===== FUNCTION ===== */
  /**
   * 데이터 전송
   * --
   */
  const handleClose = () => {
    if (isClosedRef.current) return;

    const queryString = new URLSearchParams(location.search);
    const webTransactionId = queryString.get('web_transaction_id');

    if (!webTransactionId) return;

    // 새 NICE 인증 결과를 부모 창 또는 네이티브 앱으로 한 번만 전달합니다.
    const authData = {
      type: 'NICE_AUTH',
      status: 'success',
      data: webTransactionId,
    };

    isClosedRef.current = true;

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(authData));
      return;
    }

    if (window.opener) {
      window.opener.postMessage(authData, window.location.origin);
      window.close();
    }
  };

  /**
   * 팝업창 닫기 감지
   * --
   */
  useEffect(() => {
    window.addEventListener('beforeunload', handleClose);

    return () => window.removeEventListener('beforeunload', handleClose);
    // eslint-disable-next-line
  }, []);

  /* ===== HOOKS ===== */
  return (
    <div className="auth-layout">
      <Result
        status={'success'}
        title={'인증성공'}
        subTitle={'페이지로 돌아가 다음 단계를 진행하세요.'}
        extra={[
          <Button className="auth-button" onClick={() => handleClose()}>
            돌아가기
          </Button>,
        ]}
      />
    </div>
  );
};

export default AuthSuccess;
